import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@/store";

export const selectIdentityState = (state: RootState) => state.identity;

export const selectVerifiedStatus = createSelector(
  [selectIdentityState],
  (identity) => identity.verifiedStatus,
);

export const selectKycResult = createSelector(
  [selectIdentityState],
  (identity) => ({
    firstName: identity.firstName,
    lastName: identity.lastName,
    dateOfBirth: identity.dateOfBirth,
    phoneNumber: identity.phoneNumber,
    personalAddress: identity.personalAddress,
  }),
);
